import React, { useEffect, useRef, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from '../firebase';
import Card from "../componenets/Card";
import FeedHeader from "../componenets/FeedHeader";
import MemberBanner from "../componenets/MemberBanner";
import FeedSkeleton from "../componenets/FeedSkeleton";
import { readSeenPosts, markPostsSeen } from "../lib/seenPosts";

const app_hostname = window.location.hostname === "localhost" ? "social.ambasada.pro" : window.location.hostname;

const Home = () => {
    const { track: slug } = useParams();
    const [media, setmedia] = useState([]);
    const [trackConfig, setTrackConfig] = useState(null);
    const [trackMissing, setTrackMissing] = useState(false);
    const [loading, setLoading] = useState(true);
    const seenSnapshotRef = useRef(null);
    if (seenSnapshotRef.current === null) {
        seenSnapshotRef.current = readSeenPosts();
    }

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
            try {
                const [trackSnap, mediaSnapshot] = await Promise.all([
                    getDoc(doc(db, "tracks", slug)),
                    getDocs(collection(db, "media")),
                ]);
                if (cancelled) return;
                if (!trackSnap.exists()) {
                    setTrackMissing(true);
                    return;
                }
                setTrackConfig({ id: trackSnap.id, ...trackSnap.data() });
                const tsValue = (t) => {
                    if (!t) return 0;
                    if (typeof t.toMillis === "function") return t.toMillis();
                    if (typeof t.seconds === "number") return t.seconds * 1000;
                    return new Date(t).getTime() || 0;
                };
                const mediaList = mediaSnapshot.docs
                    .map(d => {
                        const data = d.data();
                        return {
                            id: d.id,
                            ...data,
                            post_url: `https://${app_hostname}/s/${d.id}`,
                        };
                    })
                    .filter(m => m.track === slug && !m.archived)
                    .sort((a, b) => tsValue(b.timestamp) - tsValue(a.timestamp));
                setmedia(mediaList);
            } catch (error) {
                console.error("Error fetching feed: ", error);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        run();
        return () => { cancelled = true; };
    }, [slug]);

    useEffect(() => {
        if (media.length === 0) return;
        markPostsSeen(media.map((m) => m.id));
    }, [media]);

    if (trackMissing) return <Navigate to="/" replace />;

    const snapshot = seenSnapshotRef.current;
    const newCount = media.reduce((n, m) => (snapshot.has(m.id) ? n : n + 1), 0);
    const shouldDim = newCount > 0 && newCount < media.length;

    return (
        <div className="bg-brand-bg min-h-screen">
            <FeedHeader track={trackConfig} />
            <MemberBanner track={slug} />
            {loading && <FeedSkeleton />}
            {!loading && media.length === 0 && (
                <div className="max-w-7xl mx-auto px-6 sm:px-8 py-12">
                    <div className="rounded-2xl bg-white border border-brand-panel p-8 text-sm text-brand-muted text-center">
                        No posts yet in this track. First content lands soon.
                    </div>
                </div>
            )}
            {!loading && media.length > 0 && (
            <div className="max-w-7xl mx-auto px-6 sm:px-8 py-8 sm:py-10 columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-5">
                {media.map((campaign, index) => (
                    <Card
                        key={campaign.id}
                        campaign={campaign}
                        index={index}
                        track={slug}
                        dimmed={shouldDim && snapshot.has(campaign.id)}
                    />
                ))}
            </div>
            )}
        </div>
    );
};

export default Home;
